import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import BackToAdminDashboard from 'frontend/components/back-to-admin-dashboard';
import Root from 'frontend/components/assign-students/root';
import set from 'ember-set-helper/helpers/set';
<template>
  {{pageTitle (t "general.admin") " | " (t "general.unassignedStudentsSummaryTitle")}}
  <BackToAdminDashboard />
  <Root
    @model={{@controller.model}}
    @query={{@controller.query}}
    @schoolId={{@controller.schoolId}}
    @setSchoolId={{set @controller "schoolId"}}
    @setQuery={{set @controller "query"}}
  />
</template>
